import { render, staticRenderFns } from "./importParent.vue?vue&type=template&id=22a67665&"
import script from "./importParent.vue?vue&type=script&lang=js&"
export * from "./importParent.vue?vue&type=script&lang=js&"
import style0 from "./importParent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports